import Vue from 'vue';
import CustomColorAppMarker from '~/components/CustomColorAppMarker.vue';
import CustomColorSimpleAppMarker from '~/components/CustomColorSimpleAppMarker.vue';

const CustomColorAppMarkerConstructor = Vue.extend(CustomColorAppMarker);
const CustomColorSimpleAppMarkerConstructor = Vue.extend(CustomColorSimpleAppMarker);

export const generateCustomColorMarker = (color, simple = false) => {
  const props = { propsData: { fillColor: color } };
  const iconComponent = simple
    ? new CustomColorSimpleAppMarkerConstructor(props)
    : new CustomColorAppMarkerConstructor(props);

  iconComponent.$mount();
  const iconString = new XMLSerializer().serializeToString(iconComponent.$el);

  return `data:image/svg+xml;charset=UTF-8;base64,${btoa(iconString)}`;
};

export default generateCustomColorMarker;
